import { adjacentMines, flagsUsed, revealedCount, safeCount } from './legal.js';
/**
 * What a square looks like from the player's side of the board.
 *
 * A plain number rather than an object per square, which is worth explaining
 * because it is the one place on the site where the readable shape was the
 * wrong one. An expert board is four hundred and eighty squares and a full view
 * goes down the wire after *every* click; as objects that is tens of kilobytes
 * per move, and opening a large region would send the lot. As numbers it is a
 * couple of kilobytes, and the constants below give it the names back.
 *
 * Zero to eight is an open square and the number in it. Everything else is
 * negative, so `cell >= 0` is the whole test for "is this square open".
 */
export const HIDDEN = -1;
export const FLAGGED = -2;
/** A mine, unflagged. Only ever sent once the board is over. */
export const MINE = -3;
/** A mine the player had marked — the ones they got right. */
export const FLAGGED_MINE = -4;
/** A flag with nothing under it. Only worth showing after a loss. */
export const WRONG_FLAG = -5;
/** The one they stepped on. */
export const DETONATED = -6;
/**
 * No `legalMoves`, unlike every other game here.
 *
 * The other four send the player a list of what they may do, because working it
 * out needs cards the client cannot see. Here it needs nothing the client does
 * not already have: any hidden square may be opened or flagged, and a number
 * may be chorded when its flags add up — all of it readable off `cells`. A list
 * would be four hundred and eighty entries of the client telling itself
 * something it knew.
 */
export function buildView(state) {
    const { width, height } = state.rules;
    const over = state.phase !== 'playing';
    const cells = state.revealed.map((open, cell) => {
        if (open) {
            return cell === state.detonated ? DETONATED : adjacentMines(state.mines, cell, width, height);
        }
        // While the board is live, a closed square is a closed square. The mine
        // array is right here and is deliberately not consulted.
        if (!over)
            return state.flags[cell] ? FLAGGED : HIDDEN;
        if (state.mines[cell])
            return state.flags[cell] ? FLAGGED_MINE : MINE;
        return state.flags[cell] ? WRONG_FLAG : HIDDEN;
    });
    return {
        cells,
        width,
        height,
        mineCount: state.rules.mines,
        flagsLeft: state.rules.mines - flagsUsed(state),
        revealedCount: revealedCount(state),
        safeCount: safeCount(state.rules),
        phase: state.phase,
        rules: { ...state.rules },
        moveNumber: state.moveNumber,
        startedAt: null,
    };
}
//# sourceMappingURL=view.js.map